export default "__VITE_ASSET__Drr5t62c__"